"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
const useStyles = () => {
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    themeColors,
    language
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const ccTaskManagerAssignToStyle = (0, _react.useMemo)(() => {
    const deviceProps = () => {
      if (!isMobileView) {
        return {
          height: '100%',
          overflow: 'hidden',
          minHeight: pxToRem(300)
        };
      }
      return {};
    };
    const ccTaskManagerAssignTo = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      ...deviceProps()
    });
    const ccTaskManagerAssignToSelect = (0, _css.css)({
      marginBottom: pxToRem(12)
    });
    const ccTaskManagerAssignToAlert = (0, _css.css)({
      paddingInlineStart: pxToRem(14),
      lineHeight: 1.4,
      color: themeColors?.general.alert,
      fontSize: pxToRem(isMobileView ? 16 : 14),
      width: isMobileView || language === 'en' ? 'auto' : '90%',
      fontWeight: 'bold',
      marginBottom: pxToRem(12)
    });
    const ccTaskManagerAssignToAudience = (0, _css.css)({
      flex: 'auto',
      overflowX: 'hidden',
      overflowY: 'auto'
    });
    return {
      ccTaskManagerAssignTo,
      ccTaskManagerAssignToSelect,
      ccTaskManagerAssignToAlert,
      ccTaskManagerAssignToAudience
    };
  }, [isMobileView, language, pxToRem, themeColors?.general.alert]);
  return {
    'cc-TaskManager__assign-to': ccTaskManagerAssignToStyle.ccTaskManagerAssignTo,
    'cc-TaskManager__assign-to__select': ccTaskManagerAssignToStyle.ccTaskManagerAssignToSelect,
    'cc-TaskManager__assign-to__alert': ccTaskManagerAssignToStyle.ccTaskManagerAssignToAlert,
    'cc-TaskManager__assign-to__audience': ccTaskManagerAssignToStyle.ccTaskManagerAssignToAudience
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;